import React from 'react';

import Skeleton from '@atlaskit/skeleton';

export default (): React.JSX.Element => <Skeleton width="200px" height="16px" testId="skeleton" />;
